import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Center } from '@chakra-ui/react';
const FlexDividerFC = ({ withDots, sx }) => {
    return (_jsx(Center, { h: "8px", fontSize: "8px", lineHeight: "8px", letterSpacing: "2px", fontWeight: 700, borderTop: "1px", borderBottom: "1px", borderColor: "border", sx: sx, children: withDots && _jsx(_Fragment, { children: "\u2022\u2022\u2022" }) }));
};
export const FlexDivider = memo(FlexDividerFC);
//# sourceMappingURL=FlexDivider.js.map